import React, { useCallback } from 'react';
import ButtonIcon from '../../ButtonIcon';
import MenuIcon from '../../../assets/icons/menu.svg';
import { useDispatch } from 'react-redux';
import { toggleSidebar } from '../../../actions';
import { isDoctor } from '../../../../call/helpers';
const MenuControl = () => {
    const dispatch = useDispatch();
    const toggleSidebarHandle = useCallback(() => dispatch(toggleSidebar()), []);
    if (!isDoctor()) {
        return null;
    }
    return (<ButtonIcon clickHandle={toggleSidebarHandle}>
      <MenuIcon />
    </ButtonIcon>);
};
export const MenuControlKey = 'menu-control';
export default MenuControl;
